import { DataProvider } from "ra-core";

type Col = {
  field: string,
  label?: string,
  type?: 'text' | 'number',
  cb?: (row: { [key: string]: string | number }) => string | number,
}

interface XlsHtmlExporterConfig<T = { [key: string]: string | number }> {
  cols?: Array<string | Col>,
  orderBy?: Array<{ field: keyof T, order: 'asc' | 'desc', nullFirst?: boolean }>,
}

const XlsHtmlExporter = <T = { [key: string]: string | number },>(
  jsonData: Array<T>,
  _fetchRelatedRecords: (data: any, field: string, resource: string) => Promise<any>,
  _dataProvider: DataProvider,
  resource?: string,
  config?: XlsHtmlExporterConfig<T>
) => {
  if (jsonData.length > 0) {
    // Create the table element
    let table = document.createElement("table");

    // Get the keys (column names) of the first object in the JSON data
    let j = jsonData[0] as any;
    let cols: Array<string> = Object.keys(j);
    if (config && config.cols) {
      cols = config.cols.map(x => typeof x === 'string' ? x : undefined === x.label ? x.field : x.label);
    }

    // Create the header element
    let thead = document.createElement("thead");
    let tr = document.createElement("tr");

    // Loop through the column names and create header cells
    cols.forEach((item) => {
      let th = document.createElement("th");
      th.innerText = item; // Set the column name as the text of the header cell
      tr.appendChild(th); // Append the header cell to the header row
    });
    thead.appendChild(tr); // Append the header row to the header
    table.append(tr) // Append the header to the table

    if (config && config.orderBy) {
      const total = config.orderBy.length
      jsonData = jsonData.sort((a, b) => {
        for (let orderByIndex = 0; orderByIndex < total; ++orderByIndex) {
          if (config.orderBy) {
            let { field, order, nullFirst } = config.orderBy[orderByIndex];

            if (a[field] === b[field]) {

            } else if (undefined !== nullFirst && (null === a[field] || null === b[field])) {
              return (nullFirst ? 1 : -1) * ((null === a[field]) ? -1 : 1);
            } else {
              return (a[field] + '').localeCompare(b[field] + '') * ('asc' === order ? 1 : -1);
            }
          }
        }

        return 0;
      });
      // console.log(jsonData);
    }

    // Loop through the JSON data and create table rows
    jsonData.forEach((item: any) => {
      let tr = document.createElement("tr");

      // Get the values of the current object in the JSON data
      let vals = Object.values<string>(item as any);
      if (config && config.cols) {
        vals = config.cols.map(col => typeof col === 'string' ? item[col as string] : col.cb ? col.cb(item) : item[col.field]);
      }

      // Loop through the values and create table cells
      vals.forEach((elem, index) => {
        let td = document.createElement("td");
        if (config && config.cols) {
          let a = config.cols[index];
          if ('string' !== typeof a && a.type) {
            td.classList.add(a.type);
          } else {
            td.classList.add('text');
          }
        } else {
          td.classList.add('text');
        }
        td.innerText = elem; // Set the value as the text of the table cell
        tr.appendChild(td); // Append the table cell to the table row
      });
      table.appendChild(tr); // Append the table row to the table
    });

    const file = new Blob(['<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><style>.text { mso-number-format: "\@"; }</style>' + table.outerHTML], { type: "text/plain" });
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;

    a.download = `${resource}.xls`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } else {
    alert("No records");
  }
}
export default XlsHtmlExporter;
;
